export default __webpack_public_path__ + "static/media/coupon_logo.21079cda.png";